import { createFileRoute } from '@tanstack/react-router';
import { LeaveRequestsPage } from '@/features/shifts/pages/leave-requests-page';

export const Route = createFileRoute('/_app/leave-requests')({ component: LeaveRequestsPage });
